import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import useRewardPolicies from '@hooks/useRewardPolicies';
import BarcodeIcon from '@icons/BarcodeIcon';
import CouponLine from '@icons/membership/CouponLine';
import StampLine from '@icons/membership/StampLine';
import { useFlow } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import TierInfo from './TierInfo';
import UserRewardItem from './UserRewardItem';

function UserRewards() {
    const { user } = useUser();
    const { push } = useFlow();
    const { t } = useTranslation('main', { keyPrefix: 'rewards' });
    const { stampEnabled } = useRewardPolicies();
    return (
        <Column spacing={4} css={css`
            padding: 0 var(--spacing-4);
            margin-bottom: var(--spacing-12);
        `}>
            <Text color={colors.gray8} fontWeight='bold' size='headline'>
                {t('userName', {
                    name: user?.nickname
                        || user?.identityInfo?.name
                        || t('defaultName'),
                })}
            </Text>
            <TierInfo/>
            <Container>
                {stampEnabled && (
                    <Fragment>
                        <UserRewardItem icon={StampLine}
                            label={t('stamp')}
                            content={t('stampCount', { stampCount: `${user?.stampCount || 0}` })}
                            onClick={() => push('StampsActivity', {})} />
                        <Divider/>
                    </Fragment>
                )}
                <UserRewardItem icon={CouponLine}
                    label={t('coupon')}
                    content={t('couponCount', { couponCount: `${user?.couponCount || 0}` })}
                    onClick={() => push('CouponActivity', { type: 'MY' })} />
                <Divider/>
                <UserRewardItem icon={BarcodeIcon}
                    onClick={() => push('BarcodeModal', {})}
                    label={t('membership')}
                    content={t('barcode')} />
            </Container>
        </Column>
    );
}

const Container = styled.div`
    align-items: center;
    background-color: var(--color-white);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-m);
    column-gap: var(--spacing-1);
    display: flex;
    padding: var(--spacing-3) var(--spacing-2);
    width: 100%;
`;

const Divider = styled.div`
    background-color: var(--color-border-default);
    flex-shrink: 0;
    height: 40px;
    width: 1px;
`;

export default UserRewards;
